export default {"src":"/_next/static/media/LinkTree.8847a5f1.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};